import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { ActivityBone } from '../../molecules';

interface ListActivityBoneProps {
    /** Nombre d'éléments de liste */
    itemCount?: number;
    /** Styles personnalisés */
    sx?: SxProps<Theme>;
    /** Masquer les avatars/icônes de profil */
    hideProfilPictures?: boolean;
}

export const ListActivityBone: React.FunctionComponent<ListActivityBoneProps> = function ({
    itemCount = 5,
    sx = {},
    hideProfilPictures = false,
}) {
    return (
        <Box sx={{ width: '100%', ...sx }}>
            {Array.from({ length: itemCount }).map((_, index) => (
                <ActivityBone
                    key={`list-activity-${itemCount}-${index + 1}`}
                    isLast={index === itemCount - 1}
                    hideProfilPicture={hideProfilPictures}
                />
            ))}
        </Box>
    );
};
